// src/pages/Terms.js
import CmsPage from "../components/pages/CmsPage";

export default function Terms() {
  return (
    <CmsPage
      slug="terms"
      fallbackTitle="Terms & Conditions"
      fallbackContent=""
    />
  );
}
